module.exports = __webpack_public_path__ + "static/media/gal9.03c91a93.jpg";